import { useMemo } from 'react'
import { useShopCountryContext } from '@cbgms/base/shop-country/shopCountryContext'
import { ShopCountry } from '@cbgms/base/shop-id'
import useGetHelpdeskParams from 'app/auth/components/onboarding/steps/use-helpdesk-params'

export const useGetHelpCenterURL = () => {
  const { isLoading, data: generalHelpDesk } = useGetHelpdeskParams()
  const shopCountry = useShopCountryContext()
  const helpCenterURL = useMemo(() => {
    let url
    if (shopCountry && shopCountry.shopCountry === ShopCountry.NL) {
      url = new URL('https://carsys.zendesk.com/hc/nl')
    } else {
      url = new URL('https://carsys.zendesk.com/hc/en-gb')
    }

    url.searchParams.append('contactPhone', generalHelpDesk?.PhoneNumber || '')
    url.searchParams.append('contactEmail', generalHelpDesk?.Email || '')
    return url
  }, [shopCountry, generalHelpDesk])

  return { isLoading, helpCenterURL }
}
